import type { CompressionResult, CompressionStrategy } from './types';

export class IdentityCompressionStrategy implements CompressionStrategy {
  readonly name = 'identity';

  compress(payload: string): CompressionResult {
    return {
      encoding: 'identity',
      body: payload,
      originalSize: payload.length,
      compressedSize: payload.length,
    };
  }
}
